import React from 'react'
import { Button } from 'antd'

import { usePopupGoogleSignIn } from '@/contexts/AuthContext/hooks/popupGoogleSignIn'
import { CssIcon } from '@/components/CssIcon'


import { tw, cls } from 'tagged-classnames-free';
export interface IGoogleUserButtonProps {
  fill?: boolean
  className?: string
  children: React.ReactNode
}

const GoogleUserButton: React.FC<IGoogleUserButtonProps> = (props) => {
  const { className, children } = props

  const { handleGoogleSignIn } = usePopupGoogleSignIn('/sign-in-google')

  return (
    <Button
      // block
      type='primary'
      // ghost={!fill}
      className={tw`
        group
        flex h-16 items-center
        justify-center gap-x-2 rounded-lg text-lg font-semibold
        ${className}
      `}
      onClick={() => {
        handleGoogleSignIn()
      }}
    >
      <div
        className={cls`
          bg-f-text mr-auto flex size-[52px] items-center justify-center rounded
        `}
      >
        <CssIcon className={cls`i-com--logo-google   size-10`} />
      </div>
      <div className='mr-auto flex items-center gap-x-2'>
        <span>{children}</span>
        <CssIcon className='i-com--right-arrow size-6 transform duration-300 group-hover:translate-x-1' />
      </div>
    </Button>
  )
}

export default GoogleUserButton
